import { memo } from 'react';

import { merge } from '@/components';
import { Autosave, Flex, Heading, Text } from '@/components/core';
import { ExportLogo } from '@/components/logos';
import { useAutoUpdateAction } from '@/hooks/api';
import { useTriggerStore } from '@/store';
import { DivProps, formatDate, OmitChildren } from '@/utils';

export type ExportPanelHeaderProps = OmitChildren<DivProps> & {
  actionId: string;
};

const IExportPanelHeader = ({ className, actionId, ...rest }: ExportPanelHeaderProps) => {
  const action = useTriggerStore((state) => state.action);
  const { isPending, isSuccess, error } = useAutoUpdateAction(
    1000,
    { actionId },
    {
      config: action.config,
      enabled: action.enabled,
      functionId: action.functionId,
      metadata: action.metadata,
      name: action.name,
      connectionId: action.connectionId,
    }
  );

  return (
    <Flex className={merge('gap-sm items-center', className)} {...rest}>
      <ExportLogo size="xl" functionId={action.functionId} />
      <Flex col>
        <Heading>{action.name}</Heading>
        <Text variant="tertiary">Last updated: {formatDate(action.updatedTime ?? action.createdTime)}</Text>
      </Flex>

      <div className="grow" />

      <Autosave isPending={isPending} isSuccess={isSuccess} error={error} />
    </Flex>
  );
};

export const ExportPanelHeader = memo(IExportPanelHeader) as typeof IExportPanelHeader;
